export const transFormErrorResponse = error => {
  const message = error.response ? error.response?.data?.error : '';

  if (error.response && error.response.data) {
    error.response.data.message = message;
  }

  return {
    ...error,
  };
};
